// One entry per teaching block: a year, the semester it ran in, and the courses taught then.
// Each course names its undergraduate program, and the program names the institution.

export const institutions = {
  ifrs: {
    acronym: 'IFRS',
    pt: 'Instituto Federal do Rio Grande do Sul',
    en: 'Federal Institute of Rio Grande do Sul',
    url: 'https://ifrs.edu.br/',
  },
  ufsc: {
    acronym: 'UFSC',
    pt: 'Universidade Federal de Santa Catarina',
    en: 'Federal University of Santa Catarina',
    url: 'https://ufsc.br/',
  },
};

export const programs = {
  tads: {
    institution: 'ifrs',
    short: { pt: 'TADS', en: 'TADS' },
    pt: 'Tecnólogo em Análise e Desenvolvimento de Sistemas',
    en: 'Technologist in Systems Analysis and Development',
    url: 'https://ifrs.edu.br/rolante/ensino/cursos-de-graduacao/tecnologia-em-analise-e-desenvolvimento-de-sistemas/',
  },
  engcomp: {
    institution: 'ufsc',
    short: { pt: 'Eng. de Computação', en: 'Computer Engineering' },
    pt: 'Engenharia de Computação',
    en: 'Computer Engineering',
    url: 'https://enc.ufsc.br/',
  },
  tic: {
    institution: 'ufsc',
    short: { pt: 'TIC', en: 'TIC' },
    pt: 'Bacharelado em Tecnologias da Informação e Comunicação',
    en: 'Bachelor in Information and Communication Technologies',
    url: 'https://tic.ufsc.br/',
  },
};

const informationSecurity = { pt: 'Segurança da Informação', en: 'Information Security' };
const specialTopics = { pt: 'Tópicos Especiais em Computação', en: 'Special Topics in Computer Science' };
const multidisciplinary = { pt: 'Projeto Multidisciplinar', en: 'Multidisciplinary Project' };
const testing = { pt: 'Teste e Qualidade de Software', en: 'Software Testing and Quality Assurance' };
const softwareEngineering = { pt: 'Engenharia de Software I', en: 'Software Engineering I' };
const research = { pt: 'Metodologia de Pesquisa em Computação', en: 'Research Methods in Computer Science' };

// A semester can mix programs, so the program belongs to the course, not to the block.
const tads = (names, hours) => ({ ...names, hours, program: 'tads' });
const engcomp = (names, hours) => ({ ...names, hours, program: 'engcomp' });
const tic = (names, hours) => ({ ...names, hours, program: 'tic' });

export const teachingBlocks = [
  { year: 2026, span: 1, courses: [tads(multidisciplinary, 120), tads(testing, 80), tads(research, 40)] },
  {
    year: 2026,
    span: 2,
    courses: [
      engcomp({ pt: 'Redes de Computadores', en: 'Computer Networks' }, 72),
      engcomp({ pt: 'Redes sem Fio', en: 'Wireless Networks' }, 72),
      tic({ pt: 'Redes de Computadores 2', en: 'Computer Networks 2' }, 72),
    ],
  },
  { year: 2025, span: 1, courses: [tads(multidisciplinary, 120), tads(testing, 80), tads(research, 40)] },
  { year: 2025, span: 2, courses: [tads(informationSecurity, 80), tads(specialTopics, 80)] },
  { year: 2024, span: 1, courses: [tads(testing, 80), tads(softwareEngineering, 80)] },
  { year: 2024, span: 2, courses: [tads(informationSecurity, 80), tads(specialTopics, 80)] },
];

// Every program in a block belongs to the same institution, so the block shows one institution
// and names the program per course only when the semester mixes more than one.
export const blockPrograms = block => [...new Set(block.courses.map(item => item.program))];
export const blockInstitution = block => programs[block.courses[0].program].institution;

// Newest year first, with the semesters of a year in calendar order.
export const blocksByYear = [...teachingBlocks]
  .sort((a, b) => b.year - a.year || a.span - b.span)
  .reduce((years, block) => {
    const current = years.at(-1);
    if (current?.year === block.year) current.blocks.push(block);
    else years.push({ year: block.year, blocks: [block] });
    return years;
  }, []);

export const usedPrograms = [...new Set(teachingBlocks.flatMap(blockPrograms))];
export const distinctCourses = new Set(teachingBlocks.flatMap(block => block.courses.map(item => item.en))).size;
